module.exports = __webpack_public_path__ + "img/icon_vaksin.58406b8b.svg";